import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Routes from "./routers";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: Routes
});

//全局前置钩子
router.beforeEach(() => {
  NProgress.start();
});

//全局后置钩子
router.afterEach(() => {
  NProgress.done();
});
export default router;
